import { withStyles } from '@mui/styles';
import Button from '@mui/material/Button';

export const ColorButton = withStyles((theme) => ({
    root: props => ({
      color: '#ffffff', 
      backgroundColor: (props.primary??"#04c659"),'&:hover': {
        backgroundColor: (props.secondary??"darkgreen"),
      },
      fontSize: '10px',
      paddingTop: '2px',
      paddingBottom: '2px',
      paddingLeft: '5px',
      paddingRight: '5px',
      marginLeft: '5px',
      marginRight: '5px'
    }),
  }))(Button);

  export default ColorButton;